import classNames from "classnames"
import DatePicker from "legacy/DatePicker"
import MarinaSearchController from "legacy/marina-search/MarinaSearchController"
import PropTypes from "prop-types"
import React from "react"

class MapSearchFilters extends React.Component {
  constructor(props) {
    super(props)
    this.filterNameToKebabCase = this.filterNameToKebabCase.bind(this)
    this.amplitudeFilterSelected = this.amplitudeFilterSelected.bind(this)
    this.changeSelectedFilters = this.changeSelectedFilters.bind(this)
    this.searchTerm = this.searchTerm.bind(this)
    this.arrivalDate = this.arrivalDate.bind(this)
    this.departureDate = this.departureDate.bind(this)
    this.dock = this.dock.bind(this)
    this.mooring = this.mooring.bind(this)
    this.dayTrip = this.dayTrip.bind(this)
    this.amplitudeAddFiltersPressed = this.amplitudeAddFiltersPressed.bind(this)
    this.filterToggle = this.filterToggle.bind(this)
    this.amplitudeClearFiltersPressed =
      this.amplitudeClearFiltersPressed.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
    this.toggleOnlineBooking = this.toggleOnlineBooking.bind(this)
    this.toggleDockwaPlusDeal = this.toggleDockwaPlusDeal.bind(this)
    this.toggleDockwaPlusFuelDiscount =
      this.toggleDockwaPlusFuelDiscount.bind(this)
  }

  filterNameToKebabCase(filter) {
    return filter
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "")
  }

  amplitudeFilterSelected(filterId, filterName, filterValue) {
    if (this.props.experienceName === "search") {
      const eventProps = {
        experience_name: "search",
        filter_id: filterId,
        filter_name: filterName,
        filter_value: filterValue,
      }
      Amplitude.trackEvent("search:filter_selected", eventProps)
    }
  }

  changeSelectedFilters(filter, filtersSelected, filterType, event) {
    if (event.target.checked === false) {
      const remove = filtersSelected.indexOf(filter.value)
      if (remove > -1) {
        filtersSelected.splice(remove, 1)
      }
      this.amplitudeFilterSelected(filter.value, filter.label, 0)
    } else {
      this.amplitudeFilterSelected(filter.value, filter.label, 1)
      filtersSelected.push(filter.value)
    }
    if (filterType === "amenities") {
      this.props.setParentState({ selectedAmenities: filtersSelected })
    } else if (filterType === "services") {
      this.props.setParentState({ selectedServices: filtersSelected })
    } else {
      this.props.setParentState({ selectedBoatUS: filtersSelected })
    }
    this.props.mapChange()
  }

  filters(filters, filtersSelected, filterType) {
    const html = filters.map((filter) => (
      <div
        className={classNames("filter-item", {
          "col-md-4": filterType === "amenities" || filterType === "boatus",
          "col-md-3": filterType === "services",
        })}
        key={filter.value}
      >
        <div className="checkbox">
          <label>
            <input
              tabIndex={(this.props.state.filtersHidden && -1) || 0}
              type="checkbox"
              checked={filtersSelected.indexOf(filter.value) > -1}
              onChange={this.changeSelectedFilters.bind(
                null,
                filter,
                filtersSelected,
                filterType
              )}
            />
            {filterType !== "boatus" && (
              <i className={`fa-kit fa-${filter.icon_key}`} />
            )}
            {filter.label}
          </label>
        </div>
      </div>
    ))
    return html
  }

  amenities() {
    return this.filters(
      this.props.state.amenities,
      this.props.state.selectedAmenities,
      "amenities"
    )
  }

  services() {
    return this.filters(
      this.props.state.services,
      this.props.state.selectedServices,
      "services"
    )
  }

  boatus() {
    return this.filters(
      this.props.state.boatus,
      this.props.state.selectedBoatUS,
      "boatus"
    )
  }

  searchTerm(value) {
    this.props.setParentState({ searchTerm: value })
  }

  arrivalDate(value) {
    const dateFilterSelected = value ? 1 : 0
    this.amplitudeFilterSelected(
      "check-in-date",
      "Date of Arrival",
      dateFilterSelected
    )
    this.props.setParentState({ arrival: value })
    this.props.mapChange()
  }

  departureDate(value) {
    const dateFilterSelected = value ? 1 : 0
    this.amplitudeFilterSelected(
      "check-out-date",
      "Date of Departure",
      dateFilterSelected
    )
    this.props.setParentState({ departure: value })
    this.props.mapChange()
  }

  dock(event) {
    const dockFilterSelected = event.target.checked
    this.amplitudeFilterSelected("dock", "Dock", dockFilterSelected ? 1 : 0)
    this.props.setParentState({ dock: dockFilterSelected })
    this.props.mapChange()
  }

  mooring(event) {
    const mooringFilterSelected = event.target.checked
    this.amplitudeFilterSelected(
      "mooring",
      "Mooring",
      mooringFilterSelected ? 1 : 0
    )
    this.props.setParentState({ mooring: mooringFilterSelected })
    this.props.mapChange()
  }

  dayTrip(event) {
    const dayTripFilterSelected = event.target.checked
    this.amplitudeFilterSelected(
      "day-trip",
      "Day Trip",
      dayTripFilterSelected ? 1 : 0
    )
    this.props.setParentState({ dayTrip: dayTripFilterSelected })
    this.props.mapChange()
  }

  toggleOnlineBooking(event) {
    this.props.setParentState({ onlineBooking: event.target.checked })
    this.props.mapChange()
  }

  toggleDockwaPlusDeal(event) {
    const { setFilterState } = this.props
    setFilterState("dockwaPlusDeal", event.target.checked)
  }

  toggleDockwaPlusFuelDiscount(event) {
    const { setFilterState } = this.props
    setFilterState("dockwaPlusFuelDiscount", event.target.checked)
  }

  amplitudeAddFiltersPressed() {
    if (this.props.experienceName === "search") {
      const eventProps = {
        experience_name: "search",
        page_url: window.location.href,
        referrer_url: document.referrer,
      }
      Amplitude.trackEvent("search:add_filters_pressed", eventProps)
    }
  }

  filterToggle() {
    if (this.props.state.filtersHidden) {
      this.amplitudeAddFiltersPressed()
    }
    this.props.setParentState({
      filtersHidden: !this.props.state.filtersHidden,
    })
  }

  amplitudeClearFiltersPressed() {
    Amplitude.trackEvent("search:clear_filters_pressed", {
      experience_name: "search",
    })
  }

  clearFilters() {
    const { setParentState, setFilterState } = this.props

    this.amplitudeClearFiltersPressed()

    setParentState({
      selectedAmenities: [],
      selectedServices: [],
      selectedBoatUS: [],
      onlineBooking: false,
    })

    setFilterState("dockwaPlusDeal", false)
    setFilterState("dockwaPlusFuelDiscount", false)
  }

  filterButtonText() {
    if (this.props.state.filtersHidden) {
      const totalSelected =
        this.props.state.selectedServices.length +
        this.props.state.selectedAmenities.length +
        this.props.state.selectedBoatUS.length
      return (
        <span>
          Filter by Services, Amenities, & Discounts
          <strong>
            {totalSelected > 0 ? " (" + totalSelected + " selected)" : ""}
          </strong>
        </span>
      )
    } else {
      return "Hide Filters"
    }
  }

  renderDatePickers() {
    return (
      <div className="row nested-row">
        <div className="col-md-6">
          <label htmlFor={"marinaSearchStartDate"} className={"sr-only"}>
            Start Date
          </label>
          <div className="form-control-with-icon">
            <i className="fa-solid fa-calendar form-control-icon-left" />
            <DatePicker
              id="marinaSearchStartDate"
              setParentState={this.arrivalDate}
              value={this.props.state.arrival || ""}
              placeholder="Arrive"
              datesDisabled={[]}
              clearBtn={true}
              startDate={moment().format("MM/DD/YYYY")}
            />
          </div>
        </div>
        <div className="col-md-6">
          <label htmlFor={"marinaSearchEndDate"} className={"sr-only"}>
            End Date
          </label>
          <div className="form-control-with-icon">
            <i className="fa-solid fa-calendar form-control-icon-left" />
            <DatePicker
              id="marinaSearchEndDate"
              setParentState={this.departureDate}
              value={this.props.state.departure || ""}
              placeholder="Depart"
              datesDisabled={[]}
              clearBtn={true}
              startDate={moment().format("MM/DD/YYYY")}
            />
          </div>
        </div>
      </div>
    )
  }

  renderFilters() {
    return (
      <div className="row nested-row dockage-filters">
        <div className="col-md-4">
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={this.props.state.dock}
                onChange={this.dock}
              />{" "}
              Dock
            </label>
          </div>
        </div>
        <div className="col-md-4">
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={this.props.state.mooring}
                onChange={this.mooring}
              />{" "}
              Mooring
            </label>
          </div>
        </div>
        <div className="col-md-4">
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={this.props.state.dayTrip}
                onChange={this.dayTrip}
              />{" "}
              Day Trip
            </label>
          </div>
        </div>
      </div>
    )
  }

  renderFilterToggle() {
    return (
      <div className="center">
        {this.props.state.filtersHidden === false ? (
          <button
            type="button"
            className="btn btn-danger"
            onClick={this.clearFilters}
            style={{ marginRight: "15px" }}
          >
            Clear Filters
          </button>
        ) : (
          ""
        )}
        <button
          type="button"
          className="btn btn-secondary"
          onClick={this.filterToggle}
        >
          {this.filterButtonText()}
        </button>
      </div>
    )
  }

  render() {
    return (
      <div className="map-search">
        <MarinaSearchController
          setParentState={this.searchTerm}
          onMapPage={true}
          getLocation={this.props.getLocation}
          searchTerm={this.props.state.searchTerm}
          searchId={this.props.state.searchId}
          experienceName={this.props.experienceName}
          searchDebounce={this.props.searchDebounce}
        />
        {this.renderDatePickers()}
        {this.renderFilters()}
        {this.renderFilterToggle()}
        <div
          className={classNames("hidden-filters", {
            "show-filters": !this.props.state.filtersHidden,
          })}
        >
          <h2 className="text-2xl">Online Booking</h2>
          <div className="row">
            <div className="filter-item col-md-12">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={this.props.state.onlineBooking}
                    onChange={this.toggleOnlineBooking}
                  />{" "}
                  Only show marinas that accept online booking requests
                </label>
              </div>
            </div>
          </div>
          <hr />
          <h2 className="text-2xl">Dockwa+ Deals</h2>
          <div className="row">
            <div className="filter-item col-md-6">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={this.props.state.filters.dockwaPlusDeal}
                    onChange={this.toggleDockwaPlusDeal}
                  />{" "}
                  Only show marinas with Dockwa+ Deals
                </label>
              </div>
            </div>
            <div className="filter-item col-md-6">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={this.props.state.filters.dockwaPlusFuelDiscount}
                    onChange={this.toggleDockwaPlusFuelDiscount}
                  />{" "}
                  Only show marinas with Dockwa+ Fuel Discounts
                </label>
              </div>
            </div>
          </div>
          <hr />
          <h2 className="text-2xl">Services</h2>
          <div className="row">{this.services()}</div>
          <hr />
          <h2 className="text-2xl">BoatUs</h2>
          <div className="row">{this.boatus()}</div>
          <hr />
          <h2 className="text-2xl">Amenities</h2>
          <div className="row">{this.amenities()}</div>
        </div>
        <div className="flex justify-center">
          <button
            type="button"
            className="btn btn-secondary btn-show-map mt-1 lg:hidden"
            onClick={this.props.showMapMobile}
          >
            Show Map
          </button>
        </div>
      </div>
    )
  }
}

MapSearchFilters.propTypes = {
  experienceName: PropTypes.string,
  setParentState: PropTypes.func.isRequired,
  setFilterState: PropTypes.func.isRequired,
  mapChange: PropTypes.func.isRequired,
  showMapMobile: PropTypes.func.isRequired,
  getLocation: PropTypes.func.isRequired,
  searchDebounce: PropTypes.number,
  state: PropTypes.shape({
    amenities: PropTypes.array,
    services: PropTypes.array,
    boatus: PropTypes.array,
    searchId: PropTypes.string,
    filters: PropTypes.shape({
      dockwaPlusDeal: PropTypes.bool,
      dockwaPlusFuelDiscount: PropTypes.bool,
    }),
    searchTerm: PropTypes.string,
    filtersHidden: PropTypes.bool,
    selectedAmenities: PropTypes.array,
    selectedServices: PropTypes.array,
    selectedBoatUS: PropTypes.array,
    dock: PropTypes.bool,
    mooring: PropTypes.bool,
    dayTrip: PropTypes.bool,
    onlineBooking: PropTypes.bool,
    arrival: PropTypes.string,
    departure: PropTypes.string,
  }),
}

export default MapSearchFilters
